import { IconBookMarked } from "@teral/icons";
import { buttonVariants } from "../../../buttons/button";
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateHeader,
  EmptyStateIcon,
  EmptyStateTitle,
} from "../../../empty-state";

export function EmptyApiKeys() {
  return (
    <div className="w-full flex justify-center items-center h-full">
      <EmptyState frame="none" className="w-[400px]">
        <EmptyStateIcon>
          <IconBookMarked />
        </EmptyStateIcon>
        <EmptyStateHeader>
          <EmptyStateTitle>No API Keys found</EmptyStateTitle>
          <EmptyStateDescription>
            There are no API Keys configured yet. Create your first API Key to start managing
            permissions and access control.
          </EmptyStateDescription>
        </EmptyStateHeader>
        <EmptyStateActions>
          <a
            href="https://docs.teral.dev/security/overview#api-keys"
            target="_blank"
            rel="noopener noreferrer"
            className={buttonVariants({ variant: "outline" })}
          >
            <IconBookMarked />
            Learn about API Keys
          </a>
        </EmptyStateActions>
      </EmptyState>
    </div>
  );
}
